import { render, staticRenderFns } from "./OutboxMessageContent.vue?vue&type=template&id=5497197c&scoped=true"
import script from "./OutboxMessageContent.vue?vue&type=script&lang=js"
export * from "./OutboxMessageContent.vue?vue&type=script&lang=js"
import style0 from "./OutboxMessageContent.vue?vue&type=style&index=0&id=5497197c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5497197c",
  null
  
)

export default component.exports